import React from 'react'
import { Card } from '@/components/molecules/Card/Card'
import { AdvantagesLinksProps } from './types'

export function AdvantagesLinks({ advantages }: AdvantagesLinksProps) {
  return (
    <section className="p-24 flex flex-col items-center tablet:py-64 tablet:px-90 tablet:flex-row tablet:justify-between max-w-screen-desktop mx-auto tablet:items-start">
      {advantages.map((advantage) => (
        <Card
          key={advantage._uid}
          {...advantage}
          centerBtn
          className="!w-full max-w-none tablet:max-w-22 !mt-40 !mb-0 tablet:pt-0 tablet:!pl-0 tablet:!pr-32 tablet:!my-0 tablet:text-center netbook:!pr-0"
          image={undefined}
        />
      ))}
    </section>
  )
}
